import { render, staticRenderFns } from "./ClientSearchSmall.vue?vue&type=template&id=c54005a0&scoped=true"
import script from "./ClientSearchSmall.vue?vue&type=script&lang=js"
export * from "./ClientSearchSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54005a0",
  null
  
)

export default component.exports